<template>
  <!--  IF ACTIONS -->
  <section v-if="isTakeAction || isEdJusticeTakeAction" class="results-cardlist container u-white" aria-labelledby="results-list-id" data-id="results-list">
    <h2 class="visuallyhidden" id="results-list-id">
      Result List
    </h2>
    <ul class="results-cardlist__list js-waypoint-80">
      <results-list-card-item v-for="(item, index) in resultsItems" :item="item" :key="index"></results-list-card-item>
    </ul>
  </section>
  <!-- ELSE IF BILLS -->
  <section v-else-if="isBills" class="results-list container--large u-white" aria-labelledby="results-list-id" data-id="results-list">
    <h2 class="visuallyhidden" id="results-list-id">
      Result List
    </h2>
    <results-list-bill-item v-for="(item, index) in resultsItems" :item="item" :key="index"></results-list-bill-item>
  </section>
  <!-- ELSE IF LETTERS -->
  <section v-else-if="isLettersAndTestimony" class="results-list container--large u-white" aria-labelledby="results-list-id" data-id="results-list">
    <h2 class="visuallyhidden" id="results-list-id">
      Result List
    </h2>
    <results-list-letter-item v-for="(item, index) in resultsItems" :item="item" :key="index"></results-list-letter-item>
  </section>
  <!-- ELSE IF RA AGENDA OR CALENDAR OF EVENTS OR AFFILIATE CALENDAR -->
  <section v-else-if="isAnEventCalendar" class="results-list u-white container--large" aria-labelledby="results-list-id" data-id="results-list">
    <h2 class="visuallyhidden" id="results-list-id">
      Result List
    </h2>
    <results-list-event-item v-for="(item, index) in resultsItems" :item="item" :key="index"></results-list-event-item>
  </section>
  <!-- ELSE IF BUSINESS ITEMS -->
  <section v-else-if="isBusinessItems" class="results-list u-white container--large" aria-labelledby="results-list-id" data-id="results-list">
    <h2 class="visuallyhidden" id="results-list-id">
      Result List
    </h2>
    <results-list-business-item-item v-for="(item, index) in resultsItems" :item="item" :key="index"></results-list-business-item-item>
  </section>
  <!--  ELSE  -->
  <section v-else id="results-list" class="results-list u-white container--large" aria-labelledby="results-list-id" data-id="results-list">
    <h2 class="visuallyhidden" id="results-list-id">
      Result List
    </h2>
    <results-list-item v-for="(item, index) in resultsItems" :item="item" :key="index"></results-list-item>
  </section>
</template>

<script>

import ResultsListItem from "./ResultsListItem";
import {mapGetters} from "vuex"
import ResultsListCardItem from "./ResultsListCardItem";
import ResultsListBillItem from "./ResultsListBillItem";
import ResultsListLetterItem from "./ResultsListLetterItem";
import ResultsListEventItem from "@/components/ResultsListEventItem";
import ResultsListBusinessItemItem from "@/components/ResultsListBusinessItemItem";
import calendar from '@/mixins/calendar'

export default {
    name: 'ResultsList',
    mixins: [calendar],
    components: {
      ResultsListBusinessItemItem,
      ResultsListEventItem,
      ResultsListLetterItem,
      ResultsListBillItem,
      ResultsListCardItem,
      ResultsListItem
    },
    computed: {
      ...mapGetters({
        showSpinner: 'getShowSpinner',
        locked: 'getLocked',
        resultsItems: 'getResultsItems'
      }),
      isTakeAction() {
        return this.route === 'take_action'
      },
      isBills() {
        return this.route === 'bills'
      },
      isLettersAndTestimony() {
        return this.route === 'letters_and_testimony'
      },
      isBusinessItems() {
        return this.route === 'business_items'
      },
      isEdJusticeTakeAction() {
        return this.route === 'edjustice_take_action'
      },
      route () {
        return this.$route.name
      },
    }
  }

</script>
